/*
  Product gallery photos after the first one start as loading="lazy" (snippets/product-media.liquid),
  so they no longer compete with the first photo while the page loads. Swiper's own neighbour
  preloading is off in Flow, so a lazy slide would still be blank for a moment when a shopper swipes
  to it. This loads the remaining photos of the gallery the shopper can see once the page has
  finished loading, and immediately if they touch the gallery first. The copy Flow renders for the
  other device stays unloaded: Flow gives it zero height. See docs/PRODUCT-GALLERY-LOADING-2026-10-06.md.
*/
const deferredSelector = 'img[data-swe-gallery-deferred][loading="lazy"]';

const loadVisibleGalleries = () => {
  document.querySelectorAll('product-media').forEach((gallery) => {
    if (gallery.getBoundingClientRect().height === 0) return;
    // Same mechanism as Swiper's unlazy(): removing the attribute starts the download.
    gallery.querySelectorAll(deferredSelector).forEach((image) => image.removeAttribute('loading'));
  });
};

const loadWhenIdle = () => {
  if ('requestIdleCallback' in window) requestIdleCallback(loadVisibleGalleries, { timeout: 3000 });
  else setTimeout(loadVisibleGalleries, 1000);
};

const afterPageLoad = () => {
  loadWhenIdle();
  // Variant changes and quick view replace gallery markup after load.
  window.eventBus?.on?.('product:media:updated', loadWhenIdle);
  window.eventBus?.on?.('slider:media:ready', loadWhenIdle);
};

if (document.readyState === 'complete') afterPageLoad();
else window.addEventListener('load', afterPageLoad, { once: true });

document.addEventListener(
  'pointerdown',
  (event) => {
    if (event.target instanceof Element && event.target.closest('product-media')) loadVisibleGalleries();
  },
  { passive: true, capture: true }
);
